//@flow

import type {ClearancePrice} from "./clearanceTypes";


export  async function fetchClearanceProductPrices(productCodes:number[] ): Promise<{ [productId: number]: ClearancePrice }> {
    const uniqueProductCodes = [...new Set(productCodes)];
    return await ( await fetch(`/search/products/clearance/prices/batch?productCodes=${uniqueProductCodes.join(
        ","
    )}`, {
        credentials: "include",
    })).json();

}


